import React from 'react';
import Button from '../Button';

function IconButton({ iconName, ...buttonProps }) {
  return (
    <Button {...buttonProps}>
      <shore-icon name={iconName} />
    </Button>
  );
}

export default IconButton;
